import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CourseService } from '../../../../services/course.service';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';

@Component({
    selector: 'scaffold-learning',
    templateUrl: './learning.component.html',
    styleUrls: ['./learning.component.scss'],
    standalone: false
})
export class LearningComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  constructor(
    private courseService: CourseService,
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }
  public destroy$: Subject<boolean> = new Subject<boolean>();

  LearningComponent;
  ngOnInit() {
    console.log('Learning:', this);
    this.getDataComponenet();

    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  toURL(url: any): any {
    if (url) {
      if (url.match(/^https*:\/\//)) {
        return url;
      } else {
        return 'https://' + url;
      }
    }

    return null;
  }
  /**
   * For loading learningcomponent at runtime
   */
  getDataComponenet() {
    console.log(this.item);
    // if content was included in view
    if (this.item.content) {
      this.item.view = this.item.content;
    } else {
      // else get content
      if (this.item.toload_id) {
        const listUrl =
          'learningcomponent/' + this.item.toload_id + '?mode=view';
        console.log(listUrl);
        this.courseService.get(listUrl).subscribe(co => {
          this.item.view = co; // this.triggerUpdate("data view load");
          this.cdr.markForCheck();
        });
      }
    }
  }
}
